/**
 * List of constants required for ensighten tagging, we will be using on page level components to update jcpDl object
 */
const constants = {
    COUPON_PAGE_ID: 'promotions',
    COUPON_PAGE_NAME: 'jcp coupon',
    siteSection: {
        COUPON: 'promotion',
    },
    YES: 'yes',
    NO: 'no',
    EMPTY: '',
    TOF: 'tof',
};

export default constants;
